module.exports = __webpack_public_path__ + "img/benefitsHubPartner.51db09c3.png";